import { HttpClient, HttpHeaderResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { ConfigProvider } from '../../../../providers/config/config';
import { AppDetectorProvider } from '../../../../providers/detector/detector';
import { LidProvider } from '../../../../providers/lid-provider/lid-provider';

const $gameKey = "$gameKey";

@Injectable()
export class LineUpService {
  updateSub = new Subject();
  field: IField = {
    threeD: false,
    activity: {
      id: 4,
      name: "Football",
      path: 'football'
    },
    color1: "#FFFFFF",
    color2: "#294F94",
    type: TshirtType.tshirt,
    style: 0
  }

  changeMenuSub = new Subject<any>();

  constructor(
    private config: ConfigProvider,
    private lidProvider: LidProvider,
    private httpClient: HttpClient,
    private appDetector: AppDetectorProvider
     ) {
    if(!this.appDetector.isTournamentApp()) return;
    
    this.requestDisplayConfigs().then(configs => {
      configs.activity = activities[configs.activity];
      this.field = configs;
    }).catch(err => {
      console.warn("oops, there is a problem fetching the display configs: " + JSON.stringify(err));
    });
    this.initConfigs();
  }

  initField() {
    this.field = JSON.parse(localStorage.getItem($gameKey)) || this.field;
  }

  initConfigs() {
    document.documentElement.style.setProperty('--threeD', this.field.threeD ? "45deg" : "0");
    document.documentElement.style.setProperty('--tshirtcolor1', "white");
    document.documentElement.style.setProperty('--tshirtcolor2', "#294F94");
  }

  async saveDisplayConfigs(){
    return new Promise<any>(async (resolve, reject) => {
      let model = {
        lid: -1,
        activity: this.field.activity.id,
        threeD: Number(this.field.threeD),
        type: this.field.type,
        color1: this.field.color1,
        color2: this.field.color2
      };
      let lid = await this.lidProvider.getLid().then(lid => lid);
      model.lid = lid;
      let token = localStorage.getItem("token");
      let url = this.config.testServer ? `http://localhost:8080/user/${token}/display/save` : `https://spooorts.de/tournament/user/${token}/display/save`;
      let httpHeaders = new HttpHeaders();
      httpHeaders.append('Content-Type', 'application/json');
      this.httpClient.post(url, model, {
        headers: httpHeaders
      }).toPromise()
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
    });
  }

  async requestDisplayConfigs(){
    return new Promise<any>(async (resolve, reject) => {
      let token = localStorage.getItem("token");
      let url = this.config.testServer ? `http://localhost:8080/user/${token}/display` : `https://spooorts.de/tournament/user/${token}/display`;
      this.httpClient.get(url).toPromise()
      .then((res: DisplayConfigs) => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
    });
  }

  save() {
    localStorage.setItem($gameKey, JSON.stringify(this.field));
    this.saveDisplayConfigs();
  }

  isElementOver(player: any) {
    // TODO: move from lineup.ts to the service 
  }
}

export interface DisplayConfigs{
  lid?: number;
  activity: number;
  threeD: number;
  tshirt: number;
  color1: string;
  color2: string;
}

export interface ProfileConfigs{
  lid?: number;
  encounters: number;
  winScore: number;
  tieScore: number;
  lossScore: number;
}

export enum TshirtStyle {
  colored,
  horizontal,
  vertical
}

export enum TshirtType{
    bandedcollar,
    henley,
    hoodie,
    longsleeves,
    nosleeves,
    polo,
    shirt,
    tshirt,
    vneck,
    default
}

export enum ToolbarType {
  main,
  settings,
  team,
  tshirt,
  field,
  share
}

export interface IField {
  threeD: boolean;
  activity: any;
  style: number;
  color1: string;
  color2: string;
  type: TshirtType;
}

export interface IPlayer {
  id: number;
  name: string;
  memo: string;
  color1: string;
  color2: string;
  style: TshirtStyle;
  type: TshirtType;
  cX: number;
  cY: number;
}

export interface ITeam {
  id: number;
  name: string;
  results: number;
  points: number;
  ord:number;
  players: IPlayer[];
  image?: any
}

export interface IGrid {
  activeBlock: number;
  length: number;
  blocks: IBlock[];
}

export interface IBlock {
  id: number;
  isActive: boolean;
}

export interface IActivity {
  id: number;
  name: string;
  path: string;
}

export const activities = [
  {
    id: 0,
    name: "American football 1",
    path: 'american_football_1'
  },
  {
    id: 1,
    name: "American football 2",
    path: 'american_football_2'
  },
  {
    id: 2,
    name: "Baseball",
    path: 'baseball'
  },
  {
    id: 3,
    name: "Basketball",
    path: 'basketball'
  },
  {
    id: 4,
    name: "Football",
    path: 'football'
  },
  {
    id: 5,
    name: "Handball",
    path: 'handball'
  },
  {
    id: 6,
    name: "Hokey",
    path: 'hokey'
  },
  {
    id: 7,
    name: "Indoor football",
    path: 'indoor_football'
  },
  {
    id: 8,
    name: "Tennis 1",
    path: 'tennis_1'
  },
  {
    id: 9,
    name: "Tennis 2",
    path: 'tennis_2'
  },
  {
    id: 10,
    name: "Tennis 3",
    path: 'tennis_3'
  },
  {
    id: 11,
    name: "Volleyball",
    path: 'volleyball'
  },
  {
    id: 12,
    name: "Water polo",
    path: 'water_polo'
  }
];